import { render, staticRenderFns } from "./relationList.vue?vue&type=template&id=c579b86c&scoped=true&"
import script from "./relationList.vue?vue&type=script&lang=js&"
export * from "./relationList.vue?vue&type=script&lang=js&"
import style0 from "./relationList.vue?vue&type=style&index=0&id=c579b86c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c579b86c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/web2/compiere-all/pharmanord2011/template/webapps/relationlistwidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c579b86c')) {
      api.createRecord('c579b86c', component.options)
    } else {
      api.reload('c579b86c', component.options)
    }
    module.hot.accept("./relationList.vue?vue&type=template&id=c579b86c&scoped=true&", function () {
      api.rerender('c579b86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/relationList.vue"
export default component.exports